export interface PriceRangeValues {
  current: number | null;
  minimum: number | null;
  average: number | null;
  maximum: number | null;
}

export function hasCompletePriceRange(input: PriceRangeValues): input is {
  current: number;
  minimum: number;
  average: number;
  maximum: number;
} {
  return (
    input.current !== null &&
    input.minimum !== null &&
    input.average !== null &&
    input.maximum !== null
  );
}
